class BozuVacatureFilters extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.cards = Array.from(this.querySelectorAll('[data-vacature-card]'));
    this.controls = this.querySelector('[data-filter-controls]');
    this.buttonList = this.querySelector('[data-filter-buttons]');
    this.resultCount = this.querySelector('[data-result-count]');
    this.noResults = this.querySelector('[data-no-results]');

    if (!this.cards.length || !this.controls || !this.buttonList) return;

    const labelsBySlug = new Map();

    this.cards.forEach((card) => {
      const slugs = [];

      card.querySelectorAll('[data-vacature-tag]').forEach((tag) => {
        const slug = tag.dataset.vacatureTag;
        const label = tag.textContent.trim();

        if (!slug || !label) return;
        slugs.push(slug);
        if (!labelsBySlug.has(slug)) labelsBySlug.set(slug, label);
      });

      card.dataset.vacatureTags = [...new Set(slugs)].join(' ');
    });

    this.renderFilterButtons(labelsBySlug);

    const allCount = this.querySelector('[data-all-count]');
    if (allCount) allCount.textContent = this.cards.length;

    this.controls.hidden = false;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter]');
      if (!button || !this.contains(button)) return;

      this.applyFilter(button.dataset.filter, true);
    });

    const requestedFilter = new URL(window.location.href).searchParams.get('afdeling');
    this.applyFilter(labelsBySlug.has(requestedFilter) ? requestedFilter : 'all', false);
  }

  renderFilterButtons(labelsBySlug) {
    const preferredOrder = ['sales', 'marketing', 'operationeel', 'design', 'stage', 'overig'];
    const listId = this.querySelector('[data-vacature-list]')?.id;
    const entries = Array.from(labelsBySlug.entries()).sort(([slugA, labelA], [slugB, labelB]) => {
      const indexA = preferredOrder.indexOf(slugA);
      const indexB = preferredOrder.indexOf(slugB);

      if (indexA !== -1 || indexB !== -1) {
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      }

      return labelA.localeCompare(labelB, 'nl');
    });

    entries.forEach(([slug, label]) => {
      const count = this.cards.filter((card) => card.dataset.vacatureTags.split(' ').includes(slug)).length;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bozu-vacatures__filter';
      button.dataset.filter = slug;
      button.setAttribute('aria-pressed', 'false');
      if (listId) button.setAttribute('aria-controls', listId);

      const text = document.createElement('span');
      text.textContent = label;

      const counter = document.createElement('span');
      counter.className = 'bozu-vacatures__filter-count';
      counter.textContent = count;
      counter.setAttribute('aria-hidden', 'true');

      button.append(text, counter);
      this.buttonList.append(button);
    });
  }

  applyFilter(filter, updateUrl) {
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const matches = filter === 'all' || card.dataset.vacatureTags.split(' ').includes(filter);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    this.querySelectorAll('[data-filter]').forEach((button) => {
      const isActive = button.dataset.filter === filter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    if (this.resultCount) {
      this.resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'vacature' : 'vacatures'}`;
    }
    if (this.noResults) this.noResults.hidden = visibleCount !== 0;

    if (!updateUrl) return;

    const url = new URL(window.location.href);
    if (filter === 'all') {
      url.searchParams.delete('afdeling');
    } else {
      url.searchParams.set('afdeling', filter);
    }
    window.history.replaceState({}, '', url);
  }
}

if (!customElements.get('bozu-vacature-filters')) {
  customElements.define('bozu-vacature-filters', BozuVacatureFilters);
}
